import styled from 'styled-components';

export const StyledText = styled.p`
  margin-top: 8px;
  margin-bottom : 0px;
  line-height: 1.29;
 `;
